import { Control } from "ol/control";

/**
 * 地図レイヤ切替ボタン定義クラス
 */
export class MapSelector extends Control {
  /**
   * コンストラクター
   */
  constructor() {
    const pic = document.getElementById("mapSelector");

    const element = document.createElement("div");
    element.className = "map-selector-control";
    element.appendChild(pic);

    super({
      element: element,
    });
  }
}
